import React, {useEffect, useRef} from "react";
import {Box, Typography, useMediaQuery, useTheme} from "@mui/material";
import {patrocinadores} from "../PatrocinadoresImageList";
import {motion} from "framer-motion";

export default function SponsorsCarousel() {
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.down('lg'));
    const isSm = useMediaQuery(theme.breakpoints.down('md'));
    const isXs = useMediaQuery(theme.breakpoints.down('sm'));

    const imgSize = isXs ? 60 : (isSm ? 70 : (isMd ? 85 : 100));
    const gap = isXs ? 15 : (isSm ? 20 : (isMd ? 25 : 30));
    const containerHeight = isXs ? 25 : (isSm ? 30 : (isMd ? 35 : 45));

    const nRepeats = 3;
    const imgSizeWithPadding = imgSize + gap;

    let repeatedPatrocinadores = []
    for (let i = 0; i < nRepeats; i++) {
        repeatedPatrocinadores = repeatedPatrocinadores.concat(patrocinadores);
    }

    return (
        <Box sx={{
            width: "80%",
            py: {md: 4, xs: 2},
            overflow: "hidden",
            maskImage: "linear-gradient(to right, transparent, black 15%, black 85%, transparent)",
            WebkitMaskImage: "linear-gradient(to right, transparent, black 15%, black 85%, transparent)"
        }}>

            <motion.div
                style={{
                    display: "flex",
                    gap: `${gap}px`
                }}
                animate={{
                    x:[0, -(patrocinadores.length * nRepeats * imgSizeWithPadding - ((patrocinadores.length * imgSizeWithPadding)))],
                }}
                transition={{
                    repeat: Infinity,
                    repeatType: "loop",
                    duration: patrocinadores.length * 6,
                    ease: "linear",
                }}>
                {
                    repeatedPatrocinadores.map((patrocinador, i) => (
                    <Box
                        key={i}
                        sx={{
                            flex: "0 0 auto",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: imgSize * patrocinador[2],
                            height: containerHeight,
                            borderRadius: 0,
                        }}
                    >
                        <Box
                            component="img"
                            src={patrocinador[0]}
                            alt={i}
                            sx={{
                                width: "100%",
                                height: "auto",
                                objectFit: "contain",
                                // filter: "grayscale(100%)",
                                // transition: "filter 0.3s ease",
                                // "&:hover": { filter: "none" },
                            }}
                        />
                    </Box>
                ))}
            </motion.div>
        </Box>
    );
}